import { Registry } from '../../loader/di/registry.js';
import { selectLayoutSettings } from '../../loader/essentials/config-selector.js';
import { CONFIG_RESOLVER } from '../../loader/token.js';
import { Adslot } from '../modules/adslot-controller/adslot.js';
import { EffectFunction } from './index.js';

export const HEIGHT_ANIMATION_CHANGE: EffectFunction = ({ adserverAnchor }: Adslot) => {
    const { animationDuration = 2 } = Registry.lookup(CONFIG_RESOLVER).get(selectLayoutSettings());
    adserverAnchor.style.transitionProperty = 'height, min-height';
    adserverAnchor.style.transitionDuration = `${animationDuration}s`;
    return () => {
        adserverAnchor.style.transitionProperty = '';
        adserverAnchor.style.transitionDuration = '';
    };
};
